<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-select="singleSelect"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="cityName"
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>城市列表</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="960px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    新增
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="pt-6">
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <!--<v-col cols="12" md="6">
                          <v-text-field
                            v-model="template.cityId"
                            label="cityId"
                            hide-details="true"
                            dense
                            outlined
                            required
                          ></v-text-field> </v-col
                        >--><v-col cols="12" md="12">
                            <v-text-field
                              v-model="template.cityName"
                              label="*城市"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :rules="[(v) => !!v]"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      取消
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5">確定要移除此項目?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="1"></v-col
    ></v-row>
  </v-container>
</template>

<script>
import { db } from "@/firebase";
import {
  query,
  where,
  collection,
  getDocs,
  addDoc,
  setDoc,
  doc,
  // deleteDoc,
} from "firebase/firestore/lite";

export default {
  data: () => ({
    valid: true,
    boilerplate: true,
    search: "",
    singleSelect: false,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "編號",
        value: "cityId",
        width: "6%",
        sortable: false,
        align: "center",
      },
      {
        text: "城市",
        align: "start",
        sortable: false,
        value: "cityName",
      },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "6%",
      },
      // {
      //   text: "刪除",
      //   value: "actionsDel",
      //   sortable: false,
      //   align: "center",
      //   width: "6%",
      // },
    ],
    desserts: [],
    editedIndex: -1,
    defaultItem: {},
    template: {},
    transitioned: [],
    closeTimeouts: {},
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
  },

  created() {
    // this.initialize();
    this.$bus.$emit("sideBarSelectedItem:push", 6);
    this.getCitys();
  },

  methods: {
    initialize() {
      this.desserts = [];
    },
    async getCitys() {
      const querySnapshot = await getDocs(collection(db, "city"));
      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, " => ", doc.data());
        this.desserts.push(doc.data());
        this.desserts.sort((a, b) => {
          return a.cityId - b.cityId;
        });
      });
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          const q = query(
            collection(db, "city"),
            where("cityId", "==", this.template.cityId)
          );
          const querySnapshot = await getDocs(q);

          await setDoc(
            doc(db, "city", querySnapshot._docs[0].id),
            this.template
          );
        } else {
          this.template.cityId = this.desserts.length + 1;
          await addDoc(collection(db, "city"), this.template);
        }
        this.desserts = [];
        this.getCitys();
        this.$snackbar.add(`修改完成`, { color: "success" });
        this.close();
      }
    },
  },
};
</script>
<style></style>
